import { cloneElement, isValidElement, Children } from 'react';
import { Paper, Slide } from '@mui/material';

import { makeStyles } from 'tss-react/mui';
import { ObjectWithId } from '../../types/listTypes';

interface ListAsideProps<TRow extends ObjectWithId = ObjectWithId> {
  rows: Record<string, TRow>;
  ids: Array<number | string>;
  children: React.ReactNode;
}

interface CloneRowProps<TRow extends ObjectWithId = ObjectWithId> {
  rows: Record<string, TRow>;
  ids: Array<number | string>;
  record: TRow;
}

export function ListAside<TRow extends ObjectWithId = ObjectWithId>({
  rows,
  ids,
  children,
}: Partial<ListAsideProps<TRow>>) {
  const { classes, cx } = useStyles();
  return Children.map(children, (aside, index) => {
    return isValidElement(aside) ? (
      <Slide
        direction='left'
        in={(aside.props as any).isOpen as boolean}
        mountOnEnter
        unmountOnExit
      >
        <Paper
          elevation={0}
          classes={{
            root: cx(classes.aside, (aside.props as any).drawClasses),
          }}
        >
          {cloneElement(aside as React.ReactElement<CloneRowProps<TRow>>, {
            rows: rows || {},
            ids,
            record: rows?.[(aside.props as any).recordId] || ({} as TRow),
          })}
        </Paper>
      </Slide>
    ) : null;
  });
}

const useStyles = makeStyles()((theme) => ({
  aside: {
    maxWidth: '50%',
    width: '50%',
    position: 'relative',
    marginBottom: 16,
  },
}));
